import { render } from "./details.component.vue?vue&type=template&id=8e6f0148&scoped=true"
import script from "./details.component.vue?vue&type=script&lang=js"
export * from "./details.component.vue?vue&type=script&lang=js"

import "./details.component.vue?vue&type=style&index=0&id=8e6f0148&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8e6f0148"

export default script